// IntegrationIcon.tsx
import { Stack, Box, Typography } from '@mui/material';

export const PCIntegrationIcon = () => {
  const argyleLogo = '/assets/images/argyle/newLogo/Argyle Logo - 01.svg';
  const procoreLogo = '/assets/images/argyle/newLogo/PCOR.svg';
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        component="img"
        src={argyleLogo}
        alt="Argyle"
        sx={{ width: 32, height: 32 }}
      />
      <Typography variant="body2" color="text.secondary">
        ⇄
      </Typography>
      <Box
        component="img"
        src={procoreLogo}
        alt="Procore"
        sx={{ width: 32, height: 32 }}
      />
    </Stack>
  );
};
export default PCIntegrationIcon;
